import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UpdateKmPage } from './update-km.page';

const routes: Routes = [
  {
    path: '',
    component: UpdateKmPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UpdateKmPageRoutingModule {}
